import React, { useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card, message } from "antd";
import Papa from "papaparse";
import DownloadSample from "./components/DownloadSample";
import useAxios from "../../hooks/useAxios";
import swal from "sweetalert";
import exportFromJSON from "export-from-json";
import { ReactLoading } from "../Dashboard/TinManagement/import";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const requiredHeaders = [
  "callId",
  "callDuration",
  "created_date",
  "campaign",
  "call_status",
  "customer_number",
  "Name",
  "Interest",
  "Position_Applied_For",
  "English_and_Hindi",
  "Package_Confirmation",
  "Broadband_and_System_availability",
  "wfo_preferred_location",
  "qualification_extraction",
  "user_call_status",
  "wfh_preferred_location",
];

const VoiceBotUpload = () => {
  const [csvError, setCsvError] = useState("");
  const [file, setFile] = useState(null);
  const [errorData, setErrorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});

  const api = useAxios();

  const fileInputRef = useRef(null);
  const userRole = useRole();
  const [canUpload, setCanUpload] = useState(false);
  const [canDownloadSample, setCanDownloadSample] = useState(false);

  const checkPermissions = async () => {
    try {
      const uploadAllowed = await checkPermission(
        userRole,
        "voice_bot_upload_module",
        "voice_bot_upload"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "voice_bot_upload_module",
        "download_voice_bot_sample"
      );
      setCanUpload(uploadAllowed);
      setCanDownloadSample(downloadAllowed);
    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };

  React.useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const uploadFile = async () => {
    try {
      setLoading(true);
      const payload = new FormData();
      payload.append("file", file);
      const { data } = await api.post(`/voiceBot`, payload, {
        tokenType: "user",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (data.success) {
        setResponse(data);
        message.success(data?.message);
        const { summary } = data;
        const {
          updatedRecords,
          recordsAlreadyUpdated,
          recordsInserted,
          recordsNotFound,
          totalRecords,
        } = summary;
        swal({
          title: `${recordsInserted} New Records Inserted`,
          content: {
            element: "div",
            attributes: {
              innerHTML: `
              <div style="font-family: Arial, sans-serif; text-align:center; padding: 10px; padding-top:0; font-size:14px; color:#333;">
                <h2 style="color:rgba(0, 0, 0, .65);font-size:27px;padding-bottom:10px">${updatedRecords} Records Updated</h2>
                <span style="color:#0275d8;"><strong>Already Updated:</strong> ${recordsAlreadyUpdated}</span> | 
                <span style="color:#f0ad4e;"><strong>Not Found:</strong> ${recordsNotFound}</span> | 
                <span style="color:#5cb85c;"><strong>Total:</strong> ${totalRecords}</span>
              </div>   
                `,
            },
          },
          icon: "success",
          dangerMode: true,
        });
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCsvData = async (e) => {
    console.log("object");
    setResponse({});
    setCsvError("");
    setErrorData([]);
    const files = e.target.files;
    if (files[0]) {
      let selectedFile = e.target.files[0];
      let size = selectedFile.size / 1000000;
      setFile(e.target.files[0]);
      if (size < 3) {
        Papa.parse(files[0], {
          header: true,
          complete: async function (results) {
            const { data, meta } = results;

            if (
              requiredHeaders.length !== meta?.fields?.length ||
              !requiredHeaders.every((h, i) => meta?.fields?.includes(h))
            ) {
              setCsvError("Headers do not match.");
              return;
            }
            if (data.length <= 2001) {
              if (data.length !== 1) {
                let errors = [];
                const regex = /^(?:\+91|91)?[6-9]\d{9}$/;
                for (let i = 0; i < data.length; i++) {
                  const row = data[i];
                  if (!row || Object.values(row).every((v) => !v?.trim())) {
                    continue;
                  }

                  const { customer_number, wfo_preferred_location } = row;
                  console.log(row);
                  if (!customer_number?.trim()) {
                    errors.push({
                      row: i + 1,
                      ...row,
                      status: "Missing Phone Number",
                    });
                  } else if (!regex.test(customer_number?.trim())) {
                    errors.push({
                      row: i + 1,
                      ...row,
                      status: "Invalid Phone Number",
                    });
                  }
                  const loc = wfo_preferred_location?.trim()?.toLowerCase();
                  if (
                    ![
                      "gurgaon",
                      "gurugram",
                      "amritsar",
                      "pune",
                      "vadodara",
                      "kolkata",
                      "bangalore",
                    ].includes(loc) &&
                    !["not_mentioned", "not mentioned", "null","-","_", "no", "na", "n/a",""," "].includes(
                      loc
                    )
                  ) {
                    errors.push({
                      row: i + 1,
                      ...row,
                      status: "WFO Location not valid",
                    });
                  }
                }
                if (errors?.length > 0) {
                  setErrorData(errors);
                  return swal({
                    title: "Please download the Errors Report?",
                    text: "Remove errors and submit the file again!",
                    icon: "warning",
                    dangerMode: true,
                  });
                }
              } else {
                setCsvError(
                  "No data found in CSV file. Minimum two rows are required."
                );
              }
            } else {
              setCsvError("Limit exceeded! (max-2000 records are allowed)");
            }
          },
        });
      } else {
        setCsvError("file size should be less than 3 mb");
      }
    }
  };

  const downloadErrorReport = () => {
    exportFromJSON({
      data: errorData,
      fileName: "ERROR_REPORT",
      exportType: "csv",
    });
  };

  const downloadResult = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_DOMAIN}${response?.exportFile?.downloadUrl}`;
    link.download = response?.exportFile?.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const ERROR = csvError !== "" || !file;

  return (
    <Dashboard title="Voice Bot Upload">
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Card title={<DownloadSample canDownload={canDownloadSample} />}>
        <div className="d-flex gap-1">
          <div className="align-items-center d-flex">
            <div
              className="d-flex flex-column"
              style={{ position: "relative" }}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                onChange={async (e) => {
                  await handleCsvData(e);
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                  }
                }}
                required
              />
              {file && (
                <span
                  style={{
                    position: "absolute",
                    backgroundColor: "#fff",
                    left: "82px",
                    top: 3,
                    maxWidth: "140px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                  }}
                >
                  {file.name}
                </span>
              )}
              {csvError && <p className="text-danger mt-2">{csvError}</p>}
            </div>
          </div>
          <div className="">
            {canUpload && (
              <button
                disabled={ERROR || errorData.length !== 0}
                className={`btn w-100 btn ${
                  ERROR || errorData.length !== 0
                    ? "btn-secondary"
                    : "btn-primary"
                } px-3`}
                type="submit"
                onClick={uploadFile}
              >
                Submit
              </button>
            )}
          </div>
          {response?.exportFile?.path && (
            <div className="">
              <button
                disabled={ERROR || errorData.length !== 0}
                className={`btn w-100 btn ${
                  ERROR || errorData.length !== 0
                    ? "btn-secondary"
                    : "btn-primary"
                } px-3`}
                type="submit"
                onClick={downloadResult}
              >
                Download Result
              </button>
            </div>
          )}
          {errorData?.length !== 0 && (
            <div className="c">
              <button
                className={`btn w-100 btn ${"btn-primary"} px-3`}
                type="submit"
                onClick={downloadErrorReport}
              >
                Download Error
              </button>
            </div>
          )}
        </div>
      </Card>
    </Dashboard>
  );
};

export default VoiceBotUpload;
